// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFundingMethodSpecificResponseDto } from './IFundingMethodSpecificResponseDto';
import {
    IFundingMethodSpecificResponseDtoFromJSON,
    IFundingMethodSpecificResponseDtoFromJSONTyped,
    IFundingMethodSpecificResponseDtoToJSON,
    IFundingMethodSpecificResponseDtoToJSONTyped,
} from './IFundingMethodSpecificResponseDto';

/**
 * 
 * @export
 * @interface IPlanBalancesDto
 */
export interface IPlanBalancesDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanBalancesDto
     */
    total_spend?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanBalancesDto
     */
    rolled_in?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanBalancesDto
     */
    rolled_out?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanBalancesDto
     */
    miscellaneous_transactions?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanBalancesDto
     */
    adjustments_to_be_invoiced?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanBalancesDto
     */
    adjustments_not_received?: number;
    /**
     * 
     * @type {number}
     * @memberof IPlanBalancesDto
     */
    adjustments_total_received?: number;
    /**
     * 
     * @type {IFundingMethodSpecificResponseDto}
     * @memberof IPlanBalancesDto
     */
    funding_method_specific?: IFundingMethodSpecificResponseDto;
}

/**
 * Check if a given object implements the IPlanBalancesDto interface.
 */
export function instanceOfIPlanBalancesDto(value: object): value is IPlanBalancesDto {
    return true;
}

export function IPlanBalancesDtoFromJSON(json: any): IPlanBalancesDto {
    return IPlanBalancesDtoFromJSONTyped(json, false);
}

export function IPlanBalancesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanBalancesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'total_spend': json['total_spend'] == null ? undefined : json['total_spend'],
        'rolled_in': json['rolled_in'] == null ? undefined : json['rolled_in'],
        'rolled_out': json['rolled_out'] == null ? undefined : json['rolled_out'],
        'miscellaneous_transactions': json['miscellaneous_transactions'] == null ? undefined : json['miscellaneous_transactions'],
        'adjustments_to_be_invoiced': json['adjustments_to_be_invoiced'] == null ? undefined : json['adjustments_to_be_invoiced'],
        'adjustments_not_received': json['adjustments_not_received'] == null ? undefined : json['adjustments_not_received'],
        'adjustments_total_received': json['adjustments_total_received'] == null ? undefined : json['adjustments_total_received'],
        'funding_method_specific': json['funding_method_specific'] == null ? undefined : IFundingMethodSpecificResponseDtoFromJSON(json['funding_method_specific']),
    };
}

export function IPlanBalancesDtoToJSON(json: any): IPlanBalancesDto {
    return IPlanBalancesDtoToJSONTyped(json, false);
}

export function IPlanBalancesDtoToJSONTyped(value?: IPlanBalancesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_spend': value['total_spend'],
        'rolled_in': value['rolled_in'],
        'rolled_out': value['rolled_out'],
        'miscellaneous_transactions': value['miscellaneous_transactions'],
        'adjustments_to_be_invoiced': value['adjustments_to_be_invoiced'],
        'adjustments_not_received': value['adjustments_not_received'],
        'adjustments_total_received': value['adjustments_total_received'],
        'funding_method_specific': IFundingMethodSpecificResponseDtoToJSON(value['funding_method_specific']),
    };
}

